<template>
  <div>
    <div class="box">
      <el-page-header
        @back="$router.go(-1)"
        :content="content"
      ></el-page-header>
    </div>
    <el-card class="content mt20 bbb">
      <el-form
        label-position="left"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="160px"
        class="demo-ruleForm"
      >
        <el-form-item :label="$t('readList.type')" prop="type">
          <el-select v-model="ruleForm.type" :placeholder="$t('please_select')">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('readList.title')" prop="title">
          <el-input
            placeholder="15자 이내로 추천드립니다."
            show-word-limit
            v-model="ruleForm.title"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('readList.subtitle')" prop="subtitle">
          <el-input show-word-limit v-model="ruleForm.subtitle"></el-input>
        </el-form-item>
        <el-form-item
          v-if="!before_date"
          :label="$t('readList.content')"
          prop="content"
        >
          <div v-if="load">
            <SummerNote
              :id="'summernote' + new Date().getTime()"
              v-model="ruleForm.content"
            />
          </div>
        </el-form-item>
        <!-- <el-form-item
          v-if="!before_date"
          :label="$t('readList.read_calendar')"
          prop="read_calendar"
        >
          <div v-if="load">
            <SummerNote
              :id="'summernote1' + new Date().getTime()"
              v-model="ruleForm.read_calendar"
            />
          </div>
        </el-form-item>
        <el-form-item
          v-if="!before_date"
          :label="$t('readList.read_task')"
          prop="read_task"
        >
          <div v-if="load">
            <SummerNote
              :id="'summernote2' + new Date().getTime()"
              v-model="ruleForm.read_task"
            />
          </div>
        </el-form-item>
        <el-form-item
          v-if="!before_date"
          :label="$t('readList.challenge_rank')"
          prop="challenge_rank"
        >
          <div v-if="load">
            <SummerNote
              :id="'summernote3' + new Date().getTime()"
              v-model="ruleForm.challenge_rank"
            />
          </div>
        </el-form-item>
        <el-form-item
          v-if="!before_date"
          :label="$t('readList.challenge_guide')"
          prop="challenge_guide"
        >
          <div v-if="load">
            <SummerNote
              :id="'summernote4' + new Date().getTime()"
              v-model="ruleForm.challenge_guide"
            />
          </div>
        </el-form-item> -->
        <el-form-item :label="$t('readList.cover')" prop="cover">
          <upload-img
            :limitMax="1"
            :file-list="ruleForm.cover"
            @changeImgList="changeImgList"
          ></upload-img>
          <p class="img-guide">
            최대 파일 크기: 300M, 이미지 최적 사이즈: 920px * 920px(1:1 비율
            권장)
          </p>
        </el-form-item>
        <el-form-item :label="$t('readList.option')" prop="option">
          <el-input
            show-word-limit
            placeholder="맴버십 (1개월)"
            v-model="ruleForm.option"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item :label="$t('readList.option_desc')" prop="option_desc">
          <el-input
            show-word-limit
            placeholder="(설명)1개월동안 진행되는 맴버십입니다."
            v-model="ruleForm.option_desc"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('readList.other_title')" prop="other_title">
          <el-input
            show-word-limit
            placeholder="모임 참여 회원에게만 노출되는 내용입니다"
            v-model="ruleForm.other_title"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('readList.other_content')"
          prop="other_content"
        >
          <el-input
            show-word-limit
            placeholder="모임 참여 회원에게만 노출되는 내용입니다"
            v-model="ruleForm.other_content"
          ></el-input>
        </el-form-item> -->
        <el-form-item :label="$t('readList.price')" prop="price">
          <el-input
            @input="
              (res) => {
                this.ruleForm.price = +res;
              }
            "
            @mousewheel.native.prevent
            @DOMMouseScroll.native.prevent
            type="number"
            :value="ruleForm.price"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="ruleForm.type === 0"
          :label="$t('readList.club_changbi_list')"
          prop="club_changbi_list"
        >
          <div class="option-setting-table">
            <div class="table-header">
              <div class="table-col first-col">
                {{ $t('readList.book_category') }}
              </div>
              <div class="table-col center-col">
                {{ $t('readList.book_detail_category') }}
              </div>
              <div class="table-col last-col">
                <p @click="handleAddOptionSetting">
                  <img src="@/assets/img/plus-gray.png" />{{ $t('btnTip.add') }}
                </p>
              </div>
            </div>
            <div
              class="table-list"
              v-for="(value, index) in ruleForm.club_changbi_list"
              :key="index"
            >
              <div class="table-col first-col">
                <el-select
                  v-model="value.type"
                  :placeholder="$t('readList.book_select')"
                >
                  <el-option
                    v-for="item in bookCategoryOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="table-col center-col">
                <el-input
                  show-word-limit
                  :placeholder="$t('readList.book_name')"
                  v-model="value.title"
                ></el-input>
                <el-input
                  show-word-limit
                  :placeholder="$t('readList.author_name')"
                  v-model="value.author"
                ></el-input>
                <el-input
                  show-word-limit
                  :placeholder="$t('readList.line_copy')"
                  v-model="value.lineCopy"
                  style="flex: 2"
                ></el-input>
              </div>
              <div
                class="table-col last-col"
                @click="handleDeleteOptionSetting(index)"
              >
                <el-button>삭제</el-button>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item :label="$t('readList.total_num')" prop="total_num">
          <el-input
            @input="
              (res) => {
                this.ruleForm.total_num = +res;
              }
            "
            @mousewheel.native.prevent
            @DOMMouseScroll.native.prevent
            type="number"
            :value="ruleForm.total_num"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('readList.max_purchase_limit')"
          prop="max_purchase_limit"
        >
          <el-input
            @input="
              (res) => {
                this.ruleForm.max_purchase_limit = +res;
              }
            "
            @mousewheel.native.prevent
            @DOMMouseScroll.native.prevent
            type="number"
            :value="ruleForm.max_purchase_limit"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('readList.time')" prop="start_time">
          <el-date-picker
            v-model="dateValue"
            type="daterange"
            :range-separator="$t('to')"
            :start-placeholder="$t('start_date')"
            :end-placeholder="$t('end_date')"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('readList.apply_time')" prop="apply_start">
          <el-date-picker
            v-model="applyValue"
            type="daterange"
            :range-separator="$t('to')"
            :start-placeholder="$t('start_date')"
            :end-placeholder="$t('end_date')"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          v-if="ruleForm.price !== 0 && ruleForm.type === 0"
          :label="$t('readList.isbn_code')"
          prop="isbn_code"
        >
          <el-radio-group v-model="ruleForm.isbn_code">
            <el-radio disabled :label="0">{{
              $t('readList.isbn_code0')
            }}</el-radio>
            <el-radio :label="1">{{ $t('readList.isbn_code1') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="ruleForm.price !== 0 && ruleForm.type === 0"
          :label="$t('readList.isbn_content')"
          prop="isbn_content"
        >
          <el-input disabled v-model="ruleForm.isbn_content"></el-input>
        </el-form-item>
        <el-form-item
          v-if="ruleForm.price !== 0 && ruleForm.type === 0"
          :label="$t('readList.apply_type')"
          prop="apply_type"
        >
          <el-radio-group v-model="ruleForm.apply_type">
            <el-radio :label="0">{{ $t('readList.apply_type0') }}</el-radio>
            <el-radio disabled :label="1">{{
              $t('readList.apply_type1')
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="ruleForm.price !== 0 && ruleForm.type === 0"
          :label="$t('readList.is_deduction')"
          prop="is_deduction"
        >
          <el-radio-group v-model="ruleForm.is_deduction">
            <el-radio :label="false">{{
              $t('readList.is_deduction0')
            }}</el-radio>
            <el-radio disabled :label="true">{{
              $t('readList.is_deduction1')
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="ruleForm.price !== 0 && ruleForm.type === 0"
          :label="$t('readList.pay_type')"
          prop="pay_type"
        >
          <el-radio-group v-model="ruleForm.pay_type">
            <el-select
              disabled
              v-model="ruleForm.pay_type"
              :placeholder="$t('please_select')"
            >
              <el-option
                v-for="item in pay_type_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="ruleForm.price !== 0"
          :label="$t('readList.refund_desc')"
          prop="refund_desc"
        >
          <div v-if="load">
            <SummerNote
              :id="'summernote' + new Date().getTime() + 1"
              v-model="ruleForm.refund_desc"
            />
          </div>
        </el-form-item>
        <el-form-item :label="$t('readList.search_tag')" prop="search_tag">
          <el-tag
            :key="tag"
            v-for="tag in dynamicTags"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)"
          >
            {{ tag }}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          >
          </el-input>
          <el-button
            v-else
            class="button-new-tag"
            size="small"
            @click="showInput"
            >+ New Tag</el-button
          >
        </el-form-item>
        <el-form-item
          :label="$t('readList.associated_club')"
          prop="associated_task"
        >
          <el-select
            clearable
            v-model="ruleForm.associated_task"
            placeholder="select"
          >
            <el-option
              v-for="item in select_options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-button class="btn" type="primary" @click="submitForm('ruleForm')">{{
        $t('btnTip.submit')
      }}</el-button>
    </el-card>
  </div>
</template>
<script>
import time from '@/utils/timeFormat';
import uploadImg from '@/components/uploadImg';
import SummerNote from '@/components/summernote';
import myTable from '@/components/table';
import { readDetail, addRead, editRead, readTaskList } from '@/api/api';
export default {
  name: 'editRead',
  components: {
    myTable,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('readList').total_num));
      } else if (value <= 0) {
        callback(new Error('모집 인원수 최소 1명 입니다.'));
      } else {
        callback();
      }
    };
    var validateMaxLimit = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('readList').max_purchase_limit));
      } else if (value > this.ruleForm.total_num) {
        callback(
          new Error('최대 구매 가능한 수량이 모집 인원을 초과했습니다.')
        );
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        type: '',
        title: '',
        subtitle: '',
        content: '',
        cover: '',
        option: '',
        option_desc: 'none',
        club_changbi_list: [
          {
            title: '',
            author: '',
            lineCopy: '',
            type: 1,
          },
        ],
        price: 0,
        total_num: 0,
        max_purchase_limit: 1,
        start_time: '',
        end_time: '',
        apply_start: '',
        apply_end: '',
        refund_desc: '',
        search_tag: '',
        read_calendar: 'none',
        read_task: 'none',
        challenge_rank: 'none',
        challenge_guide: 'none',
        associated_task: null,
        isbn_code: 1,
        isbn_content: '1227-0938',
        apply_type: 0,
        is_deduction: false,
        pay_type: 2,
        is_club_changbi: false,
      },
      before_date: false,
      select_options: [],
      rules: {
        type: [
          {
            required: true,
            message: this.$t('readList').type,
            trigger: 'blur',
          },
        ],
        title: [
          {
            required: true,
            message: this.$t('readList').title,
            trigger: 'blur',
          },
        ],
        subtitle: [
          {
            required: true,
            message: this.$t('readList').subtitle,
            trigger: 'blur',
          },
        ],
        content: [
          {
            required: true,
            message: this.$t('readList').content,
            trigger: 'blur',
          },
        ],
        read_calendar: [
          {
            required: false,
            message: this.$t('readList').read_calendar,
            trigger: 'blur',
          },
        ],
        read_task: [
          {
            required: false,
            message: this.$t('readList').read_task,
            trigger: 'blur',
          },
        ],
        challenge_rank: [
          {
            required: false,
            message: this.$t('readList').challenge_rank,
            trigger: 'blur',
          },
        ],
        challenge_guide: [
          {
            required: false,
            message: this.$t('readList').challenge_guide,
            trigger: 'blur',
          },
        ],
        cover: [
          {
            required: true,
            message: this.$t('readList').cover,
            trigger: 'blur',
          },
        ],
        option: [
          {
            required: true,
            message: this.$t('readList').option,
            trigger: 'blur',
          },
        ],
        option_desc: [
          {
            required: false,
            message: this.$t('readList').option_desc,
            trigger: 'blur',
          },
        ],
        club_changbi_list: [
          {
            required: false,
            message: this.$t('readList').club_changbi_list,
            trigger: 'blur',
          },
        ],
        other_title: [
          {
            required: false,
            message: this.$t('readList').other_title,
            trigger: 'blur',
          },
        ],
        other_content: [
          {
            required: false,
            message: this.$t('readList').other_content,
            trigger: 'blur',
          },
        ],
        price: [
          {
            required: true,
            message: this.$t('readList').price,
            trigger: 'blur',
          },
        ],
        total_num: [
          {
            required: true,
            validator: validatePass,
            trigger: 'blur',
          },
        ],
        max_purchase_limit: [
          {
            required: true,
            validator: validateMaxLimit,
            trigger: 'blur',
          },
        ],
        start_time: [
          {
            required: true,
            message: this.$t('readList').start_time,
            trigger: 'blur',
          },
        ],
        apply_start: [
          {
            required: true,
            message: this.$t('readList').apply_start,
            trigger: 'blur',
          },
        ],
        refund_desc: [
          {
            required: true,
            message: this.$t('readList').refund_desc,
            trigger: 'blur',
          },
        ],
        isbn_code: [
          {
            required: true,
            message: this.$t('readList').isbn_code,
            trigger: 'blur',
          },
        ],
        isbn_content: [
          {
            required: true,
            message: this.$t('readList').isbn_content,
            trigger: 'blur',
          },
        ],
        apply_type: [
          {
            required: true,
            message: this.$t('readList').apply_type,
            trigger: 'blur',
          },
        ],
        is_deduction: [
          {
            required: true,
            message: this.$t('readList').is_deduction,
            trigger: 'blur',
          },
        ],
        pay_type: [
          {
            required: true,
            message: this.$t('readList').pay_type,
            trigger: 'blur',
          },
        ],
      },
      dateValue: '',
      applyValue: '',
      options: [
        { label: this.$t('readList.type0'), value: 0 },
        { label: this.$t('readList.type1'), value: 1 },
      ],
      bookCategoryOptions: [
        { label: this.$t('readList.book_category_type0'), value: 1 },
        { label: this.$t('readList.book_category_type1'), value: 2 },
        { label: this.$t('readList.book_category_type2'), value: 3 },
        { label: this.$t('readList.book_category_type3'), value: 4 },
        { label: this.$t('readList.book_category_type4'), value: 5 },
      ],
      pay_type_options: [
        { label: this.$t('readList.pay_type0'), value: 0 },
        { label: this.$t('readList.pay_type1'), value: 1 },
        { label: this.$t('readList.pay_type2'), value: 2 },
      ],
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      load: false,
    };
  },
  components: { SummerNote, uploadImg },
  computed: {
    id() {
      return Number.isNaN(Number(this.$route.query.id))
        ? undefined
        : Number(this.$route.query.id);
    },
    content() {
      return this.id === undefined
        ? this.$t('btnTip').add
        : this.$t('btnTip').edit;
    },
  },
  watch: {
    dynamicTags() {
      this.ruleForm.search_tag = this.dynamicTags.join(',');
    },
    dateValue() {
      if (this.dateValue === null) {
        this.ruleForm.start_time = '';
        this.ruleForm.end_time = '';
        return;
      }
      this.ruleForm.start_time = time.currentTime(this.dateValue[0]);
      this.ruleForm.end_time = time.currentTime(this.dateValue[1]);
    },
    applyValue() {
      if (this.applyValue === null) {
        this.ruleForm.apply_start = '';
        this.ruleForm.apply_end = '';
        return;
      }
      this.ruleForm.apply_start = time.currentTime(this.applyValue[0]);
      this.ruleForm.apply_end = time.currentTime(this.applyValue[1]);
    },
  },
  methods: {
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    changeImgList(arr) {
      if (arr.length === 0) {
        this.ruleForm.cover = '';
      } else {
        this.ruleForm.cover = arr[0];
      }
    },
    async submitForm(formName) {
      if (this.ruleForm.price === 0) {
        this.ruleForm.refund_desc = null;
        this.rules.refund_desc[0].required = false;
      } else {
        this.rules.refund_desc[0].required = true;
      }
      this.ruleForm.search_tag === '' ? (this.ruleForm.search_tag = null) : '';
      await this.$refs[formName].validate();

      if (!this.checkBlackOptionList()) {
        return this.$message.error('옵션 설정의 값이 비었습니다.');
      }

      this.ruleForm.is_club_changbi = this.ruleForm.type === 0;

      if (this.id === undefined) {
        await addRead(this.ruleForm);
      } else {
        delete this.ruleForm.create_time;
        delete this.ruleForm.update_time;
        delete this.ruleForm.apply_num;
        await editRead(this.ruleForm);
      }
      this.$router.go(-1);
    },
    async get_info() {
      const information = await readDetail(this.id);
      if (new Date(information.create_time).getTime() < 1646359365553) {
        this.before_date = true;
        this.rules.content[0].required = true;
        this.rules.read_calendar[0].required = false;
        this.rules.read_task[0].required = false;
        this.rules.challenge_rank[0].required = false;
        this.rules.challenge_guide[0].required = false;
      }
      this.dateValue = [
        new Date(information.start_time),
        new Date(information.end_time),
      ];
      this.applyValue = [
        new Date(information.apply_start),
        new Date(information.apply_end),
      ];
      this.dynamicTags = information.search_tag
        ? information.search_tag.split(',')
        : (information.search_tag = []);
      this.ruleForm = { ...information };
      this.ruleForm.isbn_code = 1;
      this.ruleForm.isbn_content = '1227-0938';
      this.ruleForm.apply_type = 0;
      this.ruleForm.is_deduction = false;
      this.ruleForm.pay_type = 2;
      this.load = true;
    },

    // 옵션 설정 추가
    handleAddOptionSetting() {
      this.ruleForm.club_changbi_list.push({
        title: '',
        author: '',
      });
    },
    // 옵션 설정 삭제
    handleDeleteOptionSetting(idx) {
      if (this.ruleForm.club_changbi_list.length > 1) {
        this.ruleForm.club_changbi_list.splice(idx, 1);
      }
    },

    // 옵션 설정의 값이 비었는지 체크
    checkBlackOptionList() {
      for (const value of this.ruleForm.club_changbi_list) {
        if (
          this.ruleForm.type === 0 &&
          (value.type == '' || value.title == '' || value.author == '')
        ) {
          return false;
        }
      }
      return true;
    },
  },
  async created() {
    if (this.$route.query.id) {
      const res = await readTaskList({ club: this.$route.query.id });
      this.select_options = res.results.map((item, index) => {
        return {
          value: item.id + '',
          label: item.title,
        };
      });
    }
    if (this.id === undefined) {
      this.load = true;
      return;
    }
    this.get_info();
  },
};
</script>
<style lang="scss" scoped>
.el-date-editor {
  margin-right: 10px;
}
.bbb {
  position: relative;
  padding-bottom: 50px;
}
.bbb .btn {
  position: absolute;
  bottom: 10px;
  right: 20px;
}
.el-tag {
  margin-right: 10px;
}
/deep/.el-select {
  width: 100%;

  .el-input__inner {
    height: 40px;
  }
  .el-input__suffix {
    height: 32px;
  }
}
.img-guide {
  color: #808080;
}

.option-setting-table {
  // max-width: 780px;
  .table-header {
    display: flex;
    background-color: #f5f5f5;

    .table-col {
      padding: 0 20px;
      color: #777c82;
    }
  }

  .table-list {
    display: flex;
    border-bottom: 1px solid #e6e6e6;

    .table-col {
      padding: 8px 10px;

      .el-input {
        flex: 1;
      }
    }
  }

  .first-col {
    width: 160px;
    border-right: 1px solid #e6e6e6;
  }
  .center-col {
    flex: 1;
    display: flex;
    gap: 8px;
  }
  .last-col {
    width: 100px;

    p {
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    img {
      width: 20px;
      height: 20px;
    }

    .el-button {
      height: 30px;
      padding: 0 20px;
      border: 1px solid #acb0b3;
    }
  }

  // .el-select {
  //   /deep/.el-input__inner {
  //     height: 40px;
  //   }
  //   .el-input__icon {
  //     line-height: auto;
  //   }
  // }
}
</style>
